import { PardotFieldSearchableSelectionTableV3 } from '../../../general/pardot-fields';
import React from 'react';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';
import { useBulkSelectWorkflow } from '@hooks';
export const PardotEmailFieldsTab = ({ index, sonarObjectId }) => {
    const targetUri = `v3/pardot/emails/${sonarObjectId}/fields`;
    const { resourceIdsUri } = useBulkSelectWorkflow({
        childType: SonarObjectTypeId.PardotField,
        parentType: SonarObjectTypeId.PardotEmail,
        sonarObjectId
    });
    return React.createElement(PardotFieldSearchableSelectionTableV3, { parentIndex: index, resourceIdsUri: resourceIdsUri, showParents: true, uri: targetUri });
};
